import { useRegisterActions, Priority } from "kbar";
import { useMemo } from "react";
import { useFormikContext } from "formik";

export default function KBarActions(props) {
    const { submitForm } = useFormikContext();

    let actions = useMemo(
        () => [
            {
                id: "articleSave",
                name: "Save",
                shortcut: ["Meta+Enter"],
                keywords: "save",
                perform: () => {
                    setTimeout(() => {
                        submitForm();
                    }, 250);
                },
                priority: Priority.HIGH,
            },
        ],
        [submitForm]
    );

    useRegisterActions(actions, [actions]);

    return null;
}
